import { KirbyPageData, baseQuery } from "."
import { KirbyImageData, imageQuery } from "./image"
import { KirbyQuerySchema } from "./kql"
import { ProgrammeGroup } from "./programmes"
import { KirbyStudentPreviewData, studentPagePreviewQuery } from "./student"

export type KirbyGroupProjectData = KirbyStudentPreviewData &
  KirbyPageData & {
    students: KirbyStudentPreviewData[]
  }
export interface KirbyProgrammePageData extends KirbyPageData {
  blurb: string
  details: string
  review: string
  brief: string
  students: (KirbyStudentPreviewData & KirbyPageData)[]
  groupProjects: KirbyGroupProjectData[]
  images: KirbyImageData[]
  allProgrammes: ProgrammeGroup[]
}

export const programmePageQuery: KirbyQuerySchema["select"] = {
  blurb: "page.blurb",
  details: "page.details.kt",
  review: "page.review.kt",
  brief: "page.brief.kt",
  allProgrammes: {
    query: `site.find("programmes").structure.toStructure`,
    select: {
      id: "structureItem.id",
      title: "structureItem.title",
      courses: {
        query: "structureItem.pages.toPages.sortBy('title')",
        select: baseQuery,
      },
    },
  },
  students: {
    query:
      "site.find('students').childrenAndDrafts.filterBy('programme', '$=', page.uuid)",
    select: {
      ...baseQuery,
      ...studentPagePreviewQuery,
    },
  },
  groupProjects: {
    query: "page.children",
    select: {
      ...baseQuery,
      ...studentPagePreviewQuery,
      students: {
        query: "page.students.toPages",
        select: {
          ...baseQuery,
          ...studentPagePreviewQuery,
        },
      },
      programme: {
        query: "page.parent",
        select: baseQuery,
      },
    },
  },
  images: {
    query: "page.images",
    select: imageQuery,
  },
}
